import React from 'react';
import { IonButton, IonIcon, IonText, IonCard, IonCardContent } from '@ionic/react';
import { arrowBack, informationCircle } from 'ionicons/icons';
import { useLocation } from 'react-router-dom';
import PaymentPageLayout from './PaymentPageLayout';
import styles from './PaymentPages.module.css';

const PaymentReturnPage: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const deviceId = queryParams.get('deviceId');

  return (
    <PaymentPageLayout title="Payment Plan">
      <div className={styles.paymentPageContainer}>
        <IonIcon
          icon={informationCircle}
          className={`${styles.icon} ${styles.info}`}
        />
        
        <IonText color="dark">
          <h1 className={styles.title}>Changes Saved</h1>
          <p className={styles.subtitle}>Your payment settings have been updated.</p>
        </IonText>
        
        <IonCard className={styles.card}>
          <IonCardContent className={styles.cardContent}>
            <p>
              Any changes you made to your subscription or payment methods have been saved.
            </p>
            <p>
              You can now return to the app to continue using your OnlyCat device.
            </p>
          </IonCardContent>
        </IonCard>
        
        {deviceId && (
          <IonButton
            expand="block"
            className={styles.button}
            routerLink={`/devices/${deviceId}`}
          >
            <IonIcon slot="start" icon={arrowBack} />
            Return to Device
          </IonButton>
        )}
      </div>
    </PaymentPageLayout>
  );
};

export default PaymentReturnPage;